import { ADMIN_ACCESS_LEVEL } from '../utils/coach_feedback';

// Who sees the v5 redesign. Widen one step at a time: 'admin', then 'beta', then 'all'.
export const V5_AUDIENCE = 'admin';

export function canUseV5(user, audience = V5_AUDIENCE) {
  if (!user) return false;
  if (audience === 'all') return true;
  if (Number(user.access_level) >= ADMIN_ACCESS_LEVEL) return true;
  return audience === 'beta' && !!user.is_beta_tester;
}
